import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ title }) => {
  return (
    <header className="component-header text-center ">
      <div className="d-sm-flex justify-content-center justify-content-sm-between py-2">
        <h3 className="text-center text-sm-left d-block d-sm-inline-block font-weight-bolder">
          {title}
        </h3>
      </div>
    </header> 
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired
};

export default Header;